"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _FinancialFormulas = require("../utils/FinancialFormulas");
var _BrixelButtonSecondary = _interopRequireDefault(require("./BrixelButtonSecondary"));
var _BrixelButtonIcon = _interopRequireDefault(require("./BrixelButtonIcon"));
var _BrixelProgressBar = _interopRequireDefault(require("./BrixelProgressBar"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
var _BrixelButtonPrimary = _interopRequireDefault(require("./BrixelButtonPrimary"));
var _BrixelInputText = _interopRequireDefault(require("./Form/BrixelInputText"));
var _BrixelButtonText = _interopRequireDefault(require("./BrixelButtonText"));
var _BrixelModal = _interopRequireDefault(require("./BrixelModal"));
var Helpers = _interopRequireWildcard(require("../utils/helper"));
var _financialCalculator = require("../resources/financialCalculator");
var _translation = _interopRequireDefault(require("../Translation/translation"));
var _reactRedux = require("react-redux");
var _exclamation = _interopRequireDefault(require("../images/IconsColored/exclamation.svg"));
var _checkIcon = _interopRequireDefault(require("../images/IconsColored/checkIcon.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const FinancingCalculator = props => {
  const {
    className = '',
    country,
    currency,
    customButton = null,
    hideText = false,
    isOffer = false,
    lang = 'en',
    offerURL = '',
    onChangeValue,
    onOpenModal,
    partner = '',
    project = 'page',
    propertyPrice,
    showMsgOnTop = true,
    translations,
    successMessage,
    unsuccessMessage
  } = props;
  const lowCountry = country.toLowerCase();
  const [formValue, setFormValue] = (0, _react.useState)({});
  const [loanToValueRatio, setLoanToValueRatio] = (0, _react.useState)(null);
  const [affordability, setAffordability] = (0, _react.useState)(null);
  const [errorField, setErrorField] = (0, _react.useState)({});
  const [goBack, setGoBack] = (0, _react.useState)(false);
  const [price, setPrice] = (0, _react.useState)(!isOffer ? propertyPrice : undefined);
  const [showPriceInput, setShowPriceInput] = (0, _react.useState)(false);
  const [maxLoanRatio, setMaxLoanRatio] = (0, _react.useState)(null);
  const [maxAffordability, setMaxAffordability] = (0, _react.useState)(null);
  const [modalData, setModalData] = (0, _react.useState)({
    state: false
  });
  (0, _react.useEffect)(() => {
    setLoanToValueRatio(null);
    setAffordability(null);
  }, [formValue, price]);
  const reset = () => {
    setPrice(propertyPrice);
    if (propertyPrice) {
      setShowPriceInput(false);
    } else {
      setShowPriceInput(true);
    }
  };
  (0, _react.useEffect)(() => {
    if (propertyPrice && !isOffer) {
      setShowPriceInput(false);
      setPrice(propertyPrice);
    } else {
      setShowPriceInput(true);
    }
  }, [propertyPrice]);
  const fieldText = (name, type) => {
    if ((0, _lodash.get)(_financialCalculator.FinacialField, `[${name}][${partner}][${type}]`, null)) {
      return _financialCalculator.FinacialField[name][partner][type];
    }
    if ((0, _lodash.get)(_financialCalculator.FinacialField, `[${name}][${country}][${type}]`, null)) {
      return _financialCalculator.FinacialField[name][country][type];
    }
    return _financialCalculator.FinacialField[name].default[type];
  };
  const calculate = () => {
    const {
      equityCapital,
      netIncome,
      grossIncome
    } = formValue;
    const errMsg = {};
    if (price && equityCapital && +equityCapital > +price) {
      errMsg.equityCapital = true;
    }
    setErrorField({
      ...errMsg
    });
    const cost = {
      equityCapital,
      income: netIncome || grossIncome
    };
    if (Object.keys(errMsg).length === 0 && price && +price > 0) {
      setLoanToValueRatio((0, _FinancialFormulas.FinancialCalculator)(lowCountry, +price, cost, partner).loanToValueRatio);
      setAffordability((0, _FinancialFormulas.FinancialCalculator)(lowCountry, +price, cost, partner).affordability);
      setMaxLoanRatio((0, _FinancialFormulas.FinancialCalculator)(lowCountry, +price, cost, partner).maxLoanRatio);
      setMaxAffordability((0, _FinancialFormulas.FinancialCalculator)(lowCountry, +price, cost, partner).maxAffordability);
      setGoBack(true);
    }
  };
  (0, _react.useEffect)(() => {
    if (onChangeValue && price) {
      const finance = {
        ...formValue
      };
      onChangeValue(affordability, loanToValueRatio, affordability && maxAffordability && affordability < maxAffordability, loanToValueRatio && maxLoanRatio && loanToValueRatio <= maxLoanRatio, finance, price);
    }
  }, [affordability, maxLoanRatio]);
  const changeValue = (val, name) => {
    setFormValue({
      ...formValue,
      [name]: val
    });
  };
  const openModal = type => {
    const FinancialModalJson = (0, _financialCalculator.FinancialModal)(lang, translations);
    const textType = partner || lowCountry;
    const curCountry = (0, _lodash.get)(FinancialModalJson, `[${textType}][${type}]`, null) ? textType : 'default';
    const getText = FinancialModalJson[curCountry][type];
    const data = {
      title: (0, _translation.default)(getText.title, lang, undefined, translations),
      body: getText.text,
      titleTopClass: 'fsize-500 fweight-600',
      small: true,
      state: true
    };
    if (onOpenModal) {
      onOpenModal(data);
    } else {
      setModalData(data);
    }
  };
  const onMakeOfferLink = () => {
    if (typeof window !== 'undefined') {
      project === 'hub' ? window.location.assign(offerURL) : window.open(offerURL, '_blank');
    }
  };
  const isUnsuccessMessage = affordability && maxAffordability && affordability > maxAffordability || loanToValueRatio && maxLoanRatio && loanToValueRatio > maxLoanRatio || null;
  const isSuccessMessage = affordability && maxAffordability && maxLoanRatio && affordability < maxAffordability && loanToValueRatio && loanToValueRatio <= maxLoanRatio || null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showMsgOnTop && isUnsuccessMessage !== null && isSuccessMessage !== null && (/*#__PURE__*/_react.default.createElement("div", {
    className: `dis-f a-c brdRadius ${isUnsuccessMessage || successMessage ? 'brdRadius brdSmall p-2 mb-4' : 'hide'} ${isUnsuccessMessage ? 'bgYellow50 brdYellow200' : ''} ${isSuccessMessage ? 'bgGreen50 brdGreen200' : ''} ${className || 'max-w-fix-1008'}`
  }, isUnsuccessMessage && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
    className: "mr-2",
    src: _exclamation.default,
    alt: "unsuccess offer"
  }), unsuccessMessage ? (/*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: unsuccessMessage
    }
  })) : (/*#__PURE__*/_react.default.createElement("p", {
    className: "txtText900 fsize-300"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "mr-small-4"
  }, (0, _translation.default)('According to your inputs the price slightly exceeds your budget. Do you want to', lang, undefined, translations)), /*#__PURE__*/_react.default.createElement("span", {
    className: "cur-poi dis-ib lh-22 td-u",
    onClick: () => onMakeOfferLink()
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "dis-con"
  }, (0, _translation.default)('make an offer', lang, undefined, translations))), /*#__PURE__*/_react.default.createElement("span", {
    className: "ml-small-4"
  }, (0, _translation.default)('anyway?', lang, undefined, translations)))))), isSuccessMessage && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
    className: "mr-2",
    src: _checkIcon.default,
    alt: "unsuccess offer"
  }), successMessage && (/*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: successMessage
    }
  })))))), /*#__PURE__*/_react.default.createElement("div", {
    className: `financingCalculator pos-r ov-h ${className || 'max-w-fix-1008'} dis-fl-col dis-fl-row-sm shadow-2dp w-perc-100 brdRadius`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "input-box w-perc-lg-40 w-perc-100 p-3 p-lg-5 pb-8 pb-sm-5 bgWhite"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "txtText900 fweight-600 mb-1"
  }, (0, _translation.default)(isOffer ? 'Your offer' : 'Price', lang, undefined, translations)), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-c jc-b"
  }, !showPriceInput ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: "txtGreen400 pt-small-6 dis-f a-b cur-poi",
    onClick: () => setShowPriceInput(true)
  }, /*#__PURE__*/_react.default.createElement("span", null, currency || 'CHF'), /*#__PURE__*/_react.default.createElement("span", {
    className: "ff-mono fsize-500 ml-1"
  }, price ? Helpers.formatNumberValue(+price, currency) : '')), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-c jc-b"
  }, /*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    icon: "minus",
    onClick: () => price ? setPrice(+price - 10000) : '',
    theme: "text",
    themeSat: 900,
    ghost: true,
    small: true
  }), /*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    className: "ml-1",
    icon: "plus",
    onClick: () => price ? setPrice(+price + 10000) : '',
    theme: "text",
    themeSat: 900,
    ghost: true,
    small: true
  })))) : (/*#__PURE__*/_react.default.createElement(_BrixelInputText.default, {
    onKeyDown: e => e.keyCode === 13 ? calculate() : '',
    className: "w-perc-100",
    input: {
      value: price,
      name: 'price',
      onChange: val => setPrice(val)
    },
    placeholder: "1.000.000",
    type: "text",
    inputMode: "decimal",
    formatType: "price",
    meta: {
      invalid: errorField.price,
      dirty: errorField.price
    },
    message: {
      error: (0, _translation.default)('The price cannot be 0', lang, undefined, translations)
    },
    unit: currency || 'CHF'
  }))), price !== propertyPrice && propertyPrice && +propertyPrice > 0 && !isOffer && (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f flex-wrap a-c txtText600 fsize-300 mt-small-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f"
  }, /*#__PURE__*/_react.default.createElement("span", null, (0, _translation.default)('Asking price:', lang, undefined, translations)), /*#__PURE__*/_react.default.createElement("span", {
    className: "ml-small-4"
  }, currency), /*#__PURE__*/_react.default.createElement("span", {
    className: "ml-small-4"
  }, Helpers.formatNumberValue(+propertyPrice, currency))), /*#__PURE__*/_react.default.createElement(_BrixelButtonText.default, {
    className: "fsize-300 ml-small-4",
    label: (0, _translation.default)('Reset', lang, undefined, translations),
    onClick: () => reset(),
    small: true
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/_react.default.createElement(_BrixelInputText.default, {
    onKeyDown: e => e.keyCode === 13 ? calculate() : '',
    label: (0, _translation.default)('Your equity capital', lang, undefined, translations),
    input: {
      value: formValue.equityCapital,
      name: 'equityCapital',
      onChange: val => changeValue(val, 'equityCapital')
    },
    placeholder: (0, _translation.default)('Equity capital', lang, undefined, translations),
    type: "text",
    inputMode: "decimal",
    formatType: "price",
    meta: {
      invalid: errorField.equityCapital,
      dirty: errorField.equityCapital
    },
    message: {
      error: (0, _translation.default)('The equity capital cannot more the property price', lang, undefined, translations)
    },
    unit: currency || 'CHF'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/_react.default.createElement(_BrixelInputText.default, {
    onKeyDown: e => e.keyCode === 13 ? calculate() : '',
    label: (0, _translation.default)(fieldText('income', 'label'), lang, undefined, translations),
    input: {
      value: formValue.netIncome,
      name: fieldText('income', 'name'),
      onChange: val => changeValue(val, fieldText('income', 'name'))
    },
    placeholder: (0, _translation.default)(fieldText('income', 'placeholder'), lang, undefined, translations),
    inputMode: "decimal",
    type: "text",
    formatType: "price",
    meta: {
      invalid: (0, _lodash.get)(errorField, fieldText('income', 'name'), null),
      dirty: (0, _lodash.get)(errorField, fieldText('income', 'name'), null)
    },
    message: {
      error: (0, _translation.default)(fieldText('income', 'errorMsg'), lang, undefined, translations)
    },
    unit: currency || 'CHF'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f pt-2"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "fsize-300 txtText400 pr-1"
  }, (0, _translation.default)('Help me with these terms', lang, undefined, translations)), /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: "info",
    color: "text",
    saturationTxt: 400,
    saturation: 400,
    onClick: () => {
      openModal('terms');
      setGoBack(false);
    }
  })), !loanToValueRatio && !affordability ? (/*#__PURE__*/_react.default.createElement(_BrixelButtonPrimary.default, {
    label: (0, _translation.default)('Calculate', lang, undefined, translations),
    rounded: true,
    onClick: () => calculate(),
    className: "mt-3 w-perc-100"
  })) : (/*#__PURE__*/_react.default.createElement(_BrixelButtonSecondary.default, {
    label: (0, _translation.default)('Calculate', lang, undefined, translations),
    rounded: true,
    onClick: () => calculate(),
    className: "mt-3 w-perc-100"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: `input-box w-perc-lg-60 w-perc-100 p-3 p-lg-5 bgPrimary50 ${goBack ? 'open' : ''} collapsed dis-fl-col ml-a`
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "hide-lg"
  }, /*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    icon: "arrow-simple-left",
    theme: "text",
    small: true,
    ghost: true,
    className: "mb-2",
    onClick: () => {
      setGoBack(false);
    }
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f  mb-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "svg-wrapper pr-1"
  }, (loanToValueRatio && loanToValueRatio <= 0 || !loanToValueRatio) && (/*#__PURE__*/_react.default.createElement("div", {
    className: "grey"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "checkmark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: "checkmark__circle ",
    cx: "26",
    cy: "26",
    r: "25",
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "checkmark__check",
    fill: "none",
    d: "M14.1 27.2l7.1 7.2 16.7-16.8"
  })))), loanToValueRatio && maxLoanRatio && loanToValueRatio > maxLoanRatio && (/*#__PURE__*/_react.default.createElement("div", {
    className: "red"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "close",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: "bars",
    d: "M4.628 13.097L13.344 4.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "bars",
    d: "M13.173 13.097L4.799 4.5"
  }))), /*#__PURE__*/_react.default.createElement("svg", {
    className: "checkmark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: "checkmark__circle",
    cx: "26",
    cy: "26",
    r: "25",
    fill: "none"
  })))), loanToValueRatio && maxLoanRatio && loanToValueRatio > 0 && loanToValueRatio <= maxLoanRatio && (/*#__PURE__*/_react.default.createElement("div", {
    className: "green"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "checkmark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: "checkmark__circle ",
    cx: "26",
    cy: "26",
    r: "25",
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "checkmark__check back",
    fill: "none",
    d: "M14.1 27.2l7.1 7.2 16.7-16.8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "checkmark__check anim",
    fill: "none",
    d: "M14.1 27.2l7.1 7.2 16.7-16.8"
  }))))), /*#__PURE__*/_react.default.createElement("span", {
    className: "fweight-600 txtText900"
  }, (0, _translation.default)('Your loan-to-value ratio', lang, undefined, translations))), /*#__PURE__*/_react.default.createElement("div", {
    className: "as-fs pl-2"
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: "info",
    color: "primary",
    onClick: () => openModal('ratio')
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "py-2"
  }, /*#__PURE__*/_react.default.createElement(_BrixelProgressBar.default, {
    rounded: true,
    showInitialStatus: true,
    progressValue: loanToValueRatio || 0,
    color: loanToValueRatio && maxLoanRatio && loanToValueRatio <= maxLoanRatio ? 'green' : 'red',
    showValue: loanToValueRatio && loanToValueRatio >= 0 || undefined,
    xlarge: true,
    fixedStep: lowCountry === 'ch' ? [{
      val: maxLoanRatio ? 66 : null,
      label: '1. Mortgage 66%'
    }, {
      val: maxLoanRatio,
      label: `Max. ${maxLoanRatio}%`
    }] : [{
      val: maxLoanRatio,
      label: `Max. ${maxLoanRatio}%`
    }],
    barBackground: "white",
    backgroundSaturation: 0,
    showInitialStatusTxt: (0, _translation.default)('Waiting for inputs…', lang, undefined, translations)
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-7"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f "
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f mb-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "svg-wrapper pr-1 pr-1"
  }, (!affordability || affordability && affordability <= 0) && (/*#__PURE__*/_react.default.createElement("div", {
    className: "grey"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "checkmark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: "checkmark__circle ",
    cx: "26",
    cy: "26",
    r: "25",
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "checkmark__check",
    fill: "none",
    d: "M14.1 27.2l7.1 7.2 16.7-16.8"
  })))), affordability && maxAffordability && affordability > maxAffordability && (/*#__PURE__*/_react.default.createElement("div", {
    className: "red"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "close",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: "bars",
    d: "M4.628 13.097L13.344 4.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "bars",
    d: "M13.173 13.097L4.799 4.5"
  }))), /*#__PURE__*/_react.default.createElement("svg", {
    className: "checkmark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: "checkmark__circle",
    cx: "26",
    cy: "26",
    r: "25",
    fill: "none"
  })))), affordability && maxAffordability && affordability > 0 && affordability <= maxAffordability && (/*#__PURE__*/_react.default.createElement("div", {
    className: "green"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "checkmark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    className: "checkmark__circle ",
    cx: "26",
    cy: "26",
    r: "25",
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "checkmark__check back",
    fill: "none",
    d: "M14.1 27.2l7.1 7.2 16.7-16.8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "checkmark__check anim",
    fill: "none",
    d: "M14.1 27.2l7.1 7.2 16.7-16.8"
  }))))), /*#__PURE__*/_react.default.createElement("span", {
    className: "fweight-600 txtText900"
  }, (0, _translation.default)('Your affordability', lang, undefined, translations))), /*#__PURE__*/_react.default.createElement("div", {
    className: "as-fs pl-2"
  }, /*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: "info",
    color: "primary",
    onClick: () => openModal('affordability')
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "py-2"
  }, /*#__PURE__*/_react.default.createElement(_BrixelProgressBar.default, {
    rounded: true,
    barBackground: "white",
    backgroundSaturation: 0,
    progressValue: affordability || 0,
    color: affordability && maxAffordability && affordability > maxAffordability ? 'red' : 'green',
    showValue: affordability && affordability >= 0 || false,
    xlarge: true,
    fixedStep: [{
      val: maxAffordability || -1,
      label: `Max. ${maxAffordability}%`
    }],
    showInitialStatus: true,
    showInitialStatusTxt: (0, _translation.default)('Waiting for inputs…', lang, undefined, translations)
  })))), (affordability && maxAffordability && affordability > maxAffordability || loanToValueRatio && maxLoanRatio && loanToValueRatio > maxLoanRatio && !hideText && !showMsgOnTop) && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, unsuccessMessage ? (/*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: unsuccessMessage
    }
  })) : (/*#__PURE__*/_react.default.createElement("p", {
    className: "mt-4 mt-lg-6 txtText900 fsize-300"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "mr-small-4"
  }, (0, _translation.default)('According to your inputs the price slightly exceeds your budget. Do you want to', lang, undefined, translations)), /*#__PURE__*/_react.default.createElement("span", {
    className: "cur-poi dis-ib lh-22 td-u",
    onClick: () => onMakeOfferLink()
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "dis-con"
  }, (0, _translation.default)('make an offer', lang, undefined, translations))), /*#__PURE__*/_react.default.createElement("span", {
    className: "ml-small-4"
  }, (0, _translation.default)('anyway?', lang, undefined, translations)))))), affordability && maxAffordability && maxLoanRatio && affordability < maxAffordability && loanToValueRatio && loanToValueRatio <= maxLoanRatio && (/*#__PURE__*/_react.default.createElement("div", {
    className: "mt-3 mt-lg-5"
  }, customButton ? (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-col"
  }, customButton.map((btn, i) => (/*#__PURE__*/_react.default.createElement(_BrixelButtonPrimary.default, {
    rounded: true,
    className: "ws-nw mt-2 as-fs",
    onClick: () => btn.onClick(),
    key: `btn_${i.toString()}`,
    label: (0, _translation.default)(btn.label, lang, undefined, translations),
    rightIcon: btn.rightIcon,
    leftIcon: btn.leftIcon,
    theme: btn.theme,
    themeSat: btn.themeSat
  }))))) : (/*#__PURE__*/_react.default.createElement(_BrixelButtonSecondary.default, {
    className: "mt-2",
    rounded: true,
    label: (0, _translation.default)('Make an offer', lang, undefined, translations),
    bgTransparent: true,
    theme: "blue",
    themeSat: 700,
    onClick: () => onMakeOfferLink()
  })))))), modalData.state && (/*#__PURE__*/_react.default.createElement(_BrixelModal.default, {
    titleTop: true,
    titleTopClass: modalData.titleTopClass,
    title: modalData.title,
    classTitle: modalData.classTitle,
    onClose: () => setModalData({
      state: false
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: (0, _lodash.get)(modalData, 'body', '')
    }
  }))));
};
const mapStateToProps = state => ({
  translations: (0, _lodash.get)(state, 'translations', {})
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(FinancingCalculator);